export default "__VITE_ASSET__CbSoH4Ml__"